import { render, staticRenderFns } from "./FeeBarChart.vue?vue&type=template&id=50dfe434&scoped=true&"
import script from "./FeeBarChart.vue?vue&type=script&lang=js&"
export * from "./FeeBarChart.vue?vue&type=script&lang=js&"
import style0 from "./FeeBarChart.vue?vue&type=style&index=0&id=50dfe434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dfe434",
  null
  
)

export default component.exports